export default "__VITE_ASSET__BPgiRFWQ__"